"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
PasswordService.$inject = ['api', 'Popeye', '$q'];
function PasswordService(api, Popeye, $q) {
    var service = {};
    service.forgotPasswordModal = function () {
        var delay = $q.defer();
        Popeye.openModal({
            templateUrl: "../scripts/core/password_reset/views/forgot-password-modal.html",
            modalClass: 'forgot-password-modal',
            controller: ['$scope', 'notify', function ($scope, notify) {
                    $scope.email = null;
                    $scope.loading = false;
                    $scope.cancel = function (err) {
                        delay.reject(err);
                    };
                    $scope.ok = function (response) {
                        delay.resolve(response);
                        Popeye.closeCurrentModal(response);
                    };
                    $scope.confirm = function () {
                        $scope.loading = true;
                        return api.post('/password-reset', { email: $scope.email }).then(function (response) {
                            $scope.ok(response);
                            $scope.loading = false;
                        }, function (error) {
                            notify.error(error.data);
                            $scope.loading = false;
                        });
                    };
                }]
        });
        return delay.promise;
    };
    return service;
}
exports.PasswordService = PasswordService;



//////////////////
// WEBPACK FOOTER
// ./scripts/core/password_reset/services/password.js
// module id = 336
// module chunks = 0